import { getLicensingStatus, getSystemFlags } from 'core/core.selectors';
import { verifyNemadigitalConfigAvailability } from 'pages/nemadigital/nemadigital.selectors';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router';
import { lazyRoute } from './lazy-route';

const NemaDigitalConfig = lazyRoute(() => import('pages/nemadigital/config/nemadigital-config.container'));

const NemaDigital = () => {
  const systemFlags = useSelector(getSystemFlags);
  const licensingStatus = useSelector(getLicensingStatus);

  const hasAccess = useSelector(verifyNemadigitalConfigAvailability);

  if (!systemFlags || !licensingStatus) {
    return null;
  }

  if (!hasAccess) {
    return <Navigate to='/hall-of-companies' />;
  }

  return <NemaDigitalConfig />;
};

export default NemaDigital;
